// src/pages/wartungsprotokoll/WartungsprotokollSeite1.jsx
import { Box, Heading, Text, Input, VStack, HStack } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import axios from "axios";

export default function WartungsprotokollSeite1({ form, setForm, speichern, pdfErstellen }) {


  const [kundenList, setKundenList] = useState([]);
  const [anlagenList, setAnlagenList] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/kunden`)
      .then((res) => setKundenList(Array.isArray(res.data) ? res.data : res.data?.kunden || []))
      .catch((err) => console.error("Error loading Kunden:", err));
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/anlagen`)
      .then((res) => setAnlagenList(Array.isArray(res.data) ? res.data : res.data?.anlagen || []))
      .catch((err) => console.error("Error loading Anlagen:", err));
  }, []);

  if (!form) return null;


  const handle = (field, val) => setForm(prev => ({ ...prev, [field]: val }));

  // simplified row (no right columns)
  const Row = ({ children }) => (
    <VStack align="stretch" spacing={2}>
      {children}
    </VStack>
  );

  return (
    <Box px={2} py={8} bg="white" borderRadius="xl" boxShadow="md" mt={8}>
      <HStack justify="space-between" align="center" mb={6}>
        <Heading size="md">Wartungsprotokoll</Heading>

          <HStack spacing={4}>
          <button
          onClick={speichern}
          style={{
            padding: "10px 20px",
            backgroundColor: "#33558b",
            color: "white",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer"
          }}
        >
          Speichern
        </button>

        <button
          onClick={pdfErstellen}
          style={{
            padding: "10px 20px",
            backgroundColor: "#38A169",
            color: "white",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer"
          }}
        >
          PDF Erstellen
        </button>
        </HStack>

      </HStack>
      <VStack spacing={8} align="stretch">

        {/* Upper fields */}
        <HStack spacing={6}>
          <VStack flex="1" align="stretch">

            <Text style={{ fontWeight: "bold" }}>Kunde wählen</Text>
            <select
              value={form.kundeId || ""}
              onChange={(e) => handle("kundeId", e.target.value)}
              style={{ padding: "7px", borderRadius: "6px", border: "1px solid #ccc", marginBottom: "7px" }}
            >
              <option value="">Kunde wählen</option>

              {kundenList.map((k) => (
                <option key={k.id} value={k.id}>
                  {k.nachname} {k.vorname}{k.firma ? ` - ${k.firma}` : ""}
                </option>
              ))}
            </select>

            <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="400px">
              <Text style={{ fontWeight: "bold" }} mb={2}>Anlage ID/Projekt Nummer auswählen</Text>
              <select
                value={form.anlagenbezeichnung || ""}
                onChange={(e) => {
                  const selectedProjektNummer = e.target.value;

                  const selectedAnlage = anlagenList.find(
                    (a) => a.projektNummer === selectedProjektNummer
                  );

                  setForm((prev) => ({
                    ...prev,
                    anlagenbezeichnung: selectedProjektNummer,
                    anlagenName: selectedAnlage?.anlagenName || "", // fill here
                  }));
                }}
              >
                <option value="">Anlage auswählen</option>
                {anlagenList.map((a) => (
                  <option key={a.id} value={a.projektNummer}>
                    {a.projektNummer}
                  </option>
                ))}
              </select>

            </Box>

            <Text mt={3}>Der Anlagenname wird nach Auswahl der Anlage-ID angezeigt. Ohne Auswahl kann das Feld nach dem Erstellen des PDFs handschriftlich ausgefüllt werden, <span style={{ fontWeight: "bold" }}>Anlagenname:</span></Text>
            <Input value={form.anlagenName || ""} readOnly border="none" fontSize="md"
              _focus={{ boxShadow: "none" }} />
          </VStack>

          <VStack flex="1" align="stretch" ml={6}>
            <Text>Vorgang (Optional)</Text>
            <Input
              value={form.vorgang}
              onChange={(e) => handle("vorgang", e.target.value)}
            />

            <Text mt={4} ml={6}>Wartungspaket</Text>
            <HStack mt={2} ml={6}>
              {["STANDARD", "DGUV_V3"].map(p => (
                <label key={p}>
                  <input
                    type="radio"
                    name="wartungspaket"
                    value={p}
                    checked={form.wartungspaket === p}
                    onChange={(e) => handle("wartungspaket", e.target.value)}
                  />{" "}
                  {p === "STANDARD" ? "Standard" : "DGUV V3"}
                </label>
              ))}
            </HStack>
          </VStack>
        </HStack>

        <Heading size="md" style={{ marginTop: "20px" }}>
          Optionale Bereiche</Heading>

        {/* DC */}
        <Box border="1px solid #ccc" p={4} maxW="900px">
          <label>
            <input
              type="checkbox"
              checked={form.dcMessungen}
              onChange={(e) => handle("dcMessungen", e.target.checked)}
            />{" "}
            DC-Messungen
          </label>

          <label style={{ marginLeft: "24px" }}>
            <input
              type="checkbox"
              checked={form.dcNurBeiUnregelmaessigkeiten}
              onChange={(e) =>
                handle("dcNurBeiUnregelmaessigkeiten", e.target.checked)
              }
            />{" "}
            nur bei Unregelmäßigkeiten {"    "}
          </label>

          <Input
            placeholder="vollständig oder Bereich"
            size="sm"
            width="250px"
            value={form.dcVollstaendigOderBereich}
            onChange={(e) => handle("dcVollstaendigOderBereich", e.target.value)}
          />
        </Box>

        <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="400px">

          <label style={{ marginLeft: "24px" }}>
            <input
              type="checkbox"
              checked={form.vollstaendigGemaessDin}
              onChange={(e) =>
                handle("vollstaendigGemaessDin", e.target.checked)
              }
            />{" "}
            vollständig gem. DIN EN 62446
          </label>
        </Box>

        {/* AC */}
        <Box border="1px solid #ccc" p={4} maxW="900px">
          <label>
            <input
              type="checkbox"
              checked={form.acMessungen}
              onChange={(e) => handle("acMessungen", e.target.checked)}
            />{" "}
            AC-Messungen
          </label>

          <label style={{ marginLeft: "24px" }}>
            <input
              type="checkbox"
              checked={form.acNurBeiUnregelmaessigkeiten}
              onChange={(e) =>
                handle("acNurBeiUnregelmaessigkeiten", e.target.checked)
              }
            />
            nur bei Unregelmäßigkeiten {"    "}
          </label>

          <Input
            placeholder="vollständig oder Bereich"
            size="sm"
            width="250px"
            value={form.acVollstaendigOderBereich}
            onChange={(e) => handle("acVollstaendigOderBereich", e.target.value)}
          />
        </Box>

        {/* Other checkboxes */}
        <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="400px">
          <Row>
            <label>
              <input
                type="checkbox"
                checked={form.zentralwechselrichter}
                onChange={(e) => handle("zentralwechselrichter", e.target.checked)}
              />{" "}
              Wartung Zentralwechselrichter
            </label>

            <label>
              <input
                type="checkbox"
                checked={form.mittelspannungsanlagenErweitert}
                onChange={(e) => handle("mittelspannungsanlagenErweitert", e.target.checked)}
              />{" "}
              Wartung Mittelspannungsanlagen erweitert
            </label>

            <label>
              <input
                type="checkbox"
                checked={form.erdungsmessungenStationen}
                onChange={(e) => handle("erdungsmessungenStationen", e.target.checked)}
              />{" "}
              Erdungsmessungen Stationen
            </label>

            <label>
              <input
                type="checkbox"
                checked={form.sichtpruefungMittelspannungsanlagen}
                onChange={(e) => handle("sichtpruefungMittelspannungsanlagen", e.target.checked)}
              />{" "}
              Sichtprüfung Mittelspannungsanlagen
            </label>
          </Row>
        </Box>

        <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="400px">

          {/* Reinigung */}
          <Row>
            <label>
              <input
                type="checkbox"
                checked={form.reinigung}
                onChange={(e) => handle("reinigung", e.target.checked)}
              />{" "}
              Reinigung
            </label>

            <HStack ml={6}>
              <label>
                <input
                  type="checkbox"
                  checked={form.reinigungWr}
                  onChange={(e) => handle("reinigungWr", e.target.checked)}
                />{" "}
                WR
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.reinigungGak}
                  onChange={(e) => handle("reinigungGak", e.target.checked)}
                />{" "}
                GAK
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.reinigungModule}
                  onChange={(e) => handle("reinigungModule", e.target.checked)}
                />{" "}
                Module
              </label>
            </HStack>
          </Row>

        </Box>

        <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="400px">
          {/* Thermografie */}
          <Row>
            <label>
              <input
                type="checkbox"
                checked={form.thermografie}
                onChange={(e) => handle("thermografie", e.target.checked)}
              />{" "}
              Thermografie
            </label>

            <HStack ml={6}>
              <label>
                <input
                  type="checkbox"
                  checked={form.thermografieVerteiler}
                  onChange={(e) => handle("thermografieVerteiler", e.target.checked)}
                />{" "}
                Verteiler
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.thermografieModule}
                  onChange={(e) => handle("thermografieModule", e.target.checked)}
                />{" "}
                Module
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.thermografieMspAnlagen}
                  onChange={(e) => handle("thermografieMspAnlagen", e.target.checked)}
                />{" "}
                MSP-Anlagen
              </label>
            </HStack>
          </Row>
        </Box>

        {/* Kennlinien */}
        <Box border="1px solid #ccc" borderRadius="md" p={4} maxW="700px" mt={3} mb={5}>
          <Row>
            <label>
              <input
                mb={3}
                type="checkbox"
                checked={form.kennlinienmessungen}
                onChange={(e) => handle("kennlinienmessungen", e.target.checked)}
              />{" "}
              Kennlinienmessungen
            </label>
          </Row>

          {/* Ersatzpunkte */}


          <Box maxW="600px" mt={4}>
            <Text>1. Ersatzpunkt</Text>
            <Input
              value={form.ersatzpunkt1}
              onChange={(e) => handle("ersatzpunkt1", e.target.value)}
              placeholder="Eingabe..."
            />
          </Box>

          <Box maxW="600px">
            <Text>2. Ersatzpunkt</Text>
            <Input
              value={form.ersatzpunkt2}
              onChange={(e) => handle("ersatzpunkt2", e.target.value)}
              placeholder="Eingabe..."
            />
          </Box>

          <Box maxW="600px">
            <Text>3. Ersatzpunkt</Text>
            <Input
              value={form.ersatzpunkt3}
              onChange={(e) => handle("ersatzpunkt3", e.target.value)}
              placeholder="Eingabe..."
            />
          </Box>

        </Box>



        <Box >
          <Text fontWeight="bold">Ziel und Vorgehensweise der Wartungsarbeiten</Text>
          <Text mt={2}>
            Die Wartungsarbeiten erfolgen unter Beachtung der anerkannten Regeln der Technik
            und der zutreffenden Bestimmungen und Vorschriften für Arbeitssicherheit.
          </Text>
        </Box>

        <Box mt={8}>
          <Text fontWeight="bold" fontSize="sm" mb={1}>
            Information zur Kontrollliste
          </Text>

          <Text fontSize="xs" lineHeight="1.2">
            Kurze Bemerkungen sind in die unter den Bereichen
            <br />
            stehenden Kästen einzutragen.
            Zusätzliche Mängelbeschreibungen sind auf einem zusätzlichen Blatt
            <br />
            zu beschreiben.
            Optionale Leistungen – nur auszuführen, wenn angekreuzt.
            Seiten 10 und 11 nur ausführen, wenn die Leistungen
            <br />
            beauftragt bzw. angekreuzt wurden.
            Vorgefundene Auffälligkeiten immer fotografieren und Standort festhalten!
          </Text>
        </Box>


      </VStack>
    </Box>
  );
}